import React from 'react';

export const parseHTMLWithBold = (input: string): React.ReactNode[] => {
	const parser = new DOMParser();
	const doc = parser.parseFromString(`<div>${input}</div>`, 'text/html');
	const root = doc.body.firstChild as HTMLElement;

	const parseNode = (node: ChildNode, key: number): React.ReactNode => {
		if (node.nodeType === Node.TEXT_NODE) {
			return node.textContent;
		}

		if (node.nodeType === Node.ELEMENT_NODE) {
			const element = node as HTMLElement;
			switch (element.tagName.toLowerCase()) {
				case 'b':
					return <b key={key}>{Array.from(node.childNodes).map((child, i) => parseNode(child, i))}</b>;
				default:
					return <span key={key}>{Array.from(node.childNodes).map((child, i) => parseNode(child, i))}</span>;
			}
		}

		return null;
	};

	return Array.from(root.childNodes).map((node, index) => parseNode(node, index));
}
